import { Rate, RoomData } from './bookingApiType';
import * as actions from './bookingType'
import { SearchState,Room } from './bookingType'

export const setSearch = (payload: Partial<SearchState>):actions.BookingSearch => ({ type: actions.BOOKING_SEARCH, payload })
export const bookingAvailabilityRequest = (payload:{ checkIn: string; checkOut: string; adults: number; children: number; infants: number }):actions.BookingAvailabilityRequest => ({ type: actions.BOOKING_AVAILABILITY_REQUEST, payload })
export const bookingAvailabilityFailure = (message: string): actions.BookingAvailabilityFailure => ({ type: actions.BOOKING_AVAILABILITY_FAILURE, payload: message });
export const setAvailability = (rooms: RoomData[]) => ({ type: actions.BOOKING_SET_AVAILABILITY, payload: rooms })
export const upsertQty = (payload: { room: RoomData; rate: Rate; qty: number }) => ({ type: actions.BOOKING_UPSERT_QTY, payload })
export const resetCart = () => ({ type: actions.BOOKING_RESET_CART })

export const applyCoupon = (code: string) => ({ type: actions.BOOKING_APPLY_COUPON_REQUEST, payload: { code } })
export const applyCouponSuccess = (code: string, discountAmount: number):actions.BookingApplyCouponSuccess => ({
  type: actions.BOOKING_APPLY_COUPON_SUCCESS, payload: { code, discountAmount }
})
export const applyCouponFailure = (message: string) => ({ type: actions.BOOKING_APPLY_COUPON_FAILURE, payload: message })
export const setGuestInfo = (info: any) => ({ type: actions.BOOKING_SET_GUEST_INFO, payload: info })
export const bookingReset = ():actions.BookingReset => ({ type: actions.BOOKING_RESET })
export const bookingClear = () => ({ type:actions.BOOKING_CLEAR_REQUEST})

export const createBooking = (payload:any) => ({ type: actions.BOOKING_CREATE_REQUEST, payload })
export const createBookingSuccess = (bookingRef: string):actions.BookingCreateSuccess => ({
  type: actions.BOOKING_CREATE_SUCCESS, payload: bookingRef
})
export const createBookingFailure = (message: string):actions.BookingCreateFailure => ({ type: actions.BOOKING_CREATE_FAILURE, payload: message })

export const getBookingStatus = (bookingRef: string, email: string): actions.GetBookingStatusRequest => ({
  type: actions.GET_BOOKING_STATUS_REQUEST,
  payload: { bookingRef, email },
});

export const getBookingStatusSuccess = (booking: actions.BookingDetailType): actions.GetBookingStatusSuccess => ({
  type: actions.GET_BOOKING_STATUS_SUCCESS,
  payload: booking,
});

export const getBookingStatusFailure = (message: string): actions.GetBookingStatusFailure => ({
  type: actions.GET_BOOKING_STATUS_FAILURE,
  payload: message,
});

/*
export const confirmHold = () => ({ type: actions.book CONFIRM_HOLD_REQUEST });
export const confirmHoldSuccess = (referenceNo: string) => ({
  type: CONFIRM_HOLD_SUCCESS, payload: { referenceNo },
});
export const confirmHoldFailure = (message: string) => ({ type: CONFIRM_HOLD_FAILURE, payload: message });
*/

